import React from 'react';
import { SvgProps, useDefaultColor } from '../core';

const Close: React.FC<SvgProps> = ({
  color,
  width = 20,
  height = 20,
  style,
  className,
  strokeWidth = 1,
}) => {
  const resolvedColor = useDefaultColor(color);

  return (
    <svg
      style={style}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
    >
      <g stroke={resolvedColor} strokeWidth={strokeWidth} fill="none">
        <path d="M2 2 L18 18" />
        <path d="M2 18 L18 2" />
      </g>
    </svg>
  );
};

export default Close;
